import React, { useState, useEffect } from 'react';
import { faPencilAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';
//Api
import volumetria_api from '../../../api/volumetria_api';
import residuo_api from '../../../api/residuo_api';
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';
import mascaras from '../../../helpers/mascaras';

//Estado inicial para a modalidade
function initialStateModalidade() {
    return {
        descricao: "",
        ativo: "Não",
        foto: true,
        tipoColetaVolumetrias: [],
        tipoColetaResiduos: [],
        indicarTipoResiduo: true,
        naoInformarVolumeNaColeta: false,
        distanciaPermitidaColeta: "0,00",
        prazoRegularizacao: "0",
        totalVistoriasEnquadramento: "0",
        totalVistoriasIguaisEnquadramento: "0",
        pgrsObrigatorio: "false"
    }
}

export default function NovaModalidadeColeta({ id, loading, setLoading, btnVoltar }) {
    //Estado que guarda os dados da modalidade de coleta
    const [modalidade, setModalidade] = useState(initialStateModalidade);

    //Estado que guarda as opções do select de unidades de medida
    const [optionsUnidadeDeMedida, setOptionsUnidadeDeMedida] = useState([]);

    //Estado que guarda as opções do select de tipos de residuos
    const [optionsTipoDeResiduo, setOptionsTipoDeResiduo] = useState([]);

    //Estado que guarda os erros dos campos obrigatorios 
    const [errors, setErrors] = useState({});

    //Campos obrigatorios do cadastro
    const campos = [
        objCampo({ name: "descricao", required: true }),
        objCampo({ name: "tipoColetaVolumetrias", required: true }),
        objCampo({ name: "tipoColetaResiduos", required: true }),
        objCampo({ name: "distanciaPermitidaColeta", required: true, number: true }),
        objCampo({ name: "prazoRegularizacao", required: true, number: true }),
        objCampo({ name: "pgrsObrigatorio", required: true }),
    ];

    //Carrega os dados dos selects de volumetria e residuos
    function loadData() {
        setLoading(true);
        volumetria_api.GetList().then(response => {
            const _optionsUnidadesDeMedida = response.data.map(volumetria => {
                return { value: volumetria.id, label: volumetria.tbVolumetria_Descricao }
            })

            residuo_api.GetList().then(response => {
                const _optionsTipoDeResiduo = response.data.map(residuo => {
                    return { value: residuo.id, label: residuo.descricao }
                })

                if (id) {
                    modalidadeColeta_api.GetItem(id).then(response => {
                        response.data.pgrsObrigatorio = response.data.pgrsObrigatorio.toString();
                        response.data.foto = response.data.foto.toString();
                        response.data.indicarTipoResiduo = response.data.indicarTipoResiduo.toString();
                        response.data.naoInformarVolumeNaColeta = response.data.naoInformarVolumeNaColeta.toString();
                        response.data.ativo = response.data.ativo.toString();
                        response.data.prazoRegularizacao = response.data.prazoRegularizacao.toString();
                        
                        response.data.tipoColetaVolumetrias = response.data.tipoColetaVolumetrias
                            .map(v => { return _optionsUnidadesDeMedida.filter(volumetria => volumetria.value == v)[0] });
                        response.data.tipoColetaResiduos = response.data.tipoColetaResiduos
                            .map(v => { return _optionsTipoDeResiduo.filter(residuo => residuo.value === v)[0] });
                        response.data.distanciaPermitidaColeta = response.data.distanciaPermitidaColeta.toFixed(2).toString().replace(".", ",");
                        setModalidade(response.data);
                    })
                }

                setOptionsTipoDeResiduo(_optionsTipoDeResiduo);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));

            setOptionsUnidadeDeMedida(_optionsUnidadesDeMedida);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        })
    }

    //Carrega os dados dos selects e da volumetria selecionada caso tenha
    useEffect(() => {
        loadData();
    }, []);

    //Change para os campos da modalidade
    const onChangeModalidade = (e, select) => {
        const campo = select && select.name ? campos.filter(c => c.name == select.name) : campos.filter(c => c.name == e.target.name);

        if (select && select.name) {
            const _modalidade = {
                ...modalidade,
                [select.name]: e
            }
            const erros = validarCampos(_modalidade, campo);
            if (erros[1].length == 0) {
                const _errors = { ...errors };
                delete _errors[select.name];
                setErrors(_errors);
            } else {
                setErrors({ ...errors, ...erros[0] });
            }
            setModalidade(_modalidade);

        } else {
            const { name, value } = e.target;
            const _modalidade = {
                ...modalidade,
                [name]: value
            }
            const erros = validarCampos(_modalidade, campo);
            if (erros[1].length == 0) {
                const _errors = { ...errors };
                delete _errors[name];
                setErrors(_errors);
            } else {
                setErrors({ ...errors, ...erros[0] });
            }
            setModalidade(_modalidade);
        }
    }

    //Carrega os erros nos campos obrigatorios
    const loadErrors = () => {
        const erros = validarCampos(modalidade, campos);
        setErrors(erros[0]);
        return erros[1];
    };

    //Envia os dados para a api
    const submitModalidade = () => {
        
        const _errors = loadErrors();
        if (_errors.length == 0) {
            const _modalidade = {
                ...modalidade,
                foto: modalidade.foto == true || modalidade.foto == "true",
                indicarTipoResiduo: modalidade.indicarTipoResiduo == true || modalidade.indicarTipoResiduo == "true",
                tipoColetaResiduos: modalidade.tipoColetaResiduos.map(v => v.value),
                tipoColetaVolumetrias: modalidade.tipoColetaVolumetrias.map(v => v.value),
                distanciaPermitidaColeta: modalidade.distanciaPermitidaColeta.replace(",", ".")
            }
           
            setLoading(true);
            if (id) {
                modalidadeColeta_api.Put(_modalidade).then(response => {
                    showMessage("Sucesso", "Sucesso ao editar a modalidade de coleta", "success", btnVoltar);
                    setLoading(false);
                }).catch(e => {
                    showMessage("Aviso", e.message, "error", null)
                    setLoading(false);
                });
            } else {
                modalidadeColeta_api.Post(_modalidade).then(response => {
                    showMessage("Sucesso", "Sucesso ao adicionar a modalidade de coleta", "success", btnVoltar);
                    setModalidade(initialStateModalidade);
                    setLoading(false);
                }).catch(e => {
                    showMessage("Aviso", e.message, "error", null)
                    setLoading(false);
                });
            }
        }
    }
    if (loading) {
        return <Loading />
    }

    return (
        <MainCard btnVoltar={btnVoltar}>
            <h4 className='mt-4'><FontAwesomeIcon icon={faPencilAlt} /> Identificação da modalidade de coleta</h4>
            <Row className='mb-4'>
                <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <FormGroup tag="fieldset">
                        <legend className='label'>Ativo?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="ativo"
                                        onChange={onChangeModalidade}
                                        value={"Não"}
                                        checked={modalidade.ativo === "Não" ? true : false}
                                    />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="ativo"
                                        onChange={onChangeModalidade}
                                        value={"Sim"}
                                        checked={modalidade.ativo === "Sim" ? true : false}
                                    />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                    </FormGroup>
                </Col>
                <Col md="12" lg="4">
                    <FormGroup tag="fieldset">
                        <legend className='label'>Tirar foto da coleta?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="foto"
                                        onChange={onChangeModalidade}
                                        value={"false"}
                                        checked={modalidade.foto === "false" || modalidade.foto === false ? true : false}
                                    />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="foto"
                                        onChange={onChangeModalidade}
                                        value={"true"} checked={modalidade.foto === "true" || modalidade.foto === true ? true : false}
                                    />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                    </FormGroup>
                </Col>

                <Col md="12" lg="4">
                    <FormGroup tag="fieldset">
                        <legend className='label'>Indicar Tipo de Residuo na Coleta?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="indicarTipoResiduo"
                                        onChange={onChangeModalidade}
                                        value={"false"} checked={modalidade.indicarTipoResiduo == "false" || modalidade.indicarTipoResiduo == false ? true : false}
                                    />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="indicarTipoResiduo"
                                        onChange={onChangeModalidade}
                                        value={"true"} 
                                        checked={modalidade.indicarTipoResiduo == "true" || modalidade.indicarTipoResiduo == true ? true : false}
                                    />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                    </FormGroup>
                </Col>
                <Col md="12" lg="4">
                    <FormGroup tag="fieldset">
                        <legend className='label'>Não informar volume na coleta?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="naoInformarVolumeNaColeta"
                                        onChange={onChangeModalidade}
                                        value={"false"}
                                        checked={modalidade.naoInformarVolumeNaColeta === "false" || modalidade.naoInformarVolumeNaColeta === false ? true : false}
                                    />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="naoInformarVolumeNaColeta"
                                        onChange={onChangeModalidade}
                                        value={"true"}
                                        checked={modalidade.naoInformarVolumeNaColeta === "true" || modalidade.naoInformarVolumeNaColeta === true ? true : false}
                                    />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                    </FormGroup>
                </Col>
                <Col md="12" lg="4">
                    <FormGroup tag="fieldset">
                        <legend className='label'>PGRS Obrigatório?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="pgrsObrigatorio"
                                        onChange={onChangeModalidade}
                                        value={"false"}
                                        checked={modalidade.pgrsObrigatorio == "false" || modalidade.pgrsObrigatorio == false ? true : false}
                                    />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="pgrsObrigatorio"
                                        onChange={onChangeModalidade}
                                        value={"true"} 
                                        checked={modalidade.pgrsObrigatorio == "true" || modalidade.pgrsObrigatorio == true ? true : false}
                                    />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="6">
                    <TextField
                        maxLength={"50"}
                        label={"* Descrição"}
                        name={"descricao"}
                        onChange={onChangeModalidade}
                        value={modalidade.descricao}
                        invalid={errors.descricao ? true : false}
                    />
                    {errors.descricao && <span className={"form-control-label text-danger"}>{errors.descricao.message}</span>}
                </Col>
                <Col md="12" lg="6">
                    <TextField
                        mask={mascaras.floatMask}
                        label={"* Distância permitida da coleta"}
                        name={"distanciaPermitidaColeta"}
                        onChange={onChangeModalidade}
                        value={modalidade.distanciaPermitidaColeta}
                        invalid={errors.distanciaPermitidaColeta ? true : false}
                    />
                    {errors.distanciaPermitidaColeta && <span className={"form-control-label text-danger"}>{errors.distanciaPermitidaColeta.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        label={"* Prazo para regularização do contrato"}
                        mask={mascaras.numeroMask}
                        name={"prazoRegularizacao"}
                        onChange={onChangeModalidade}
                        value={modalidade.prazoRegularizacao}
                        invalid={errors.prazoRegularizacao ? true : false}
                    />
                    {errors.prazoRegularizacao && <span className={"form-control-label text-danger"}>{errors.prazoRegularizacao.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        label={"* Total de vistorias para enquadramento"}
                        mask={mascaras.numeroMask}
                        name={"totalVistoriasEnquadramento"}
                        onChange={onChangeModalidade}
                        value={modalidade.totalVistoriasEnquadramento}
                        invalid={errors.totalVistoriasEnquadramento ? true : false}
                    />
                    {errors.totalVistoriasEnquadramento && <span className={"form-control-label text-danger"}>{errors.totalVistoriasEnquadramento.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        label={"* Total de vistorias iguais para enquadramento"}
                        mask={mascaras.numeroMask}
                        name={"totalVistoriasIguaisEnquadramento"}
                        onChange={onChangeModalidade}
                        value={modalidade.totalVistoriasIguaisEnquadramento}
                        invalid={errors.totalVistoriasIguaisEnquadramento ? true : false}
                    />
                    {errors.totalVistoriasIguaisEnquadramento && <span className={"form-control-label text-danger"}>{errors.totalVistoriasIguaisEnquadramento.message}</span>}
                </Col>
                <Col md="12" lg="12">
                    <TextField
                        invalid={errors.tipoColetaVolumetrias ? true : false}
                        label={"* Unidade de medida"}
                        options={optionsUnidadeDeMedida}
                        type={"select"}
                        multiple
                        name={"tipoColetaVolumetrias"}
                        onChange={onChangeModalidade}
                        value={modalidade.tipoColetaVolumetrias}
                    />
                    {errors.tipoColetaVolumetrias && <span className={"form-control-label text-danger"}>{errors.tipoColetaVolumetrias.message}</span>}
                </Col>
                <Col md="12" lg="12">
                    <TextField
                        label={"* Tipo de residuo"}
                        multiple
                        options={optionsTipoDeResiduo}
                        type={"select"}
                        name={"tipoColetaResiduos"}
                        onChange={onChangeModalidade}
                        value={modalidade.tipoColetaResiduos}
                        invalid={errors.tipoColetaResiduos ? true : false}
                    />
                    {errors.tipoColetaResiduos && <span className={"form-control-label text-danger"}>{errors.tipoColetaResiduos.message}</span>}
                </Col>
            </Row>

            <Row>
                <Col md="12" lg="12" className='mt-4 d-flex align-items-center justify-content-center'>
                    <Button
                        onClick={submitModalidade}
                        color={id ? "warning text-light" : "success"}
                        className='bg-gradient'
                    >
                        {id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : '+ Adicionar'}
                    </Button>
                </Col>
            </Row>
        </MainCard>
    )
}